module.exports = __webpack_public_path__ + "static/media/AdobeCC_Step1a_Image14h.85c085a9.jpg";